import { pxToRem } from '../../shared/pipes/px-to-rem.pipe';

export const TextareaDT = {
	textarea: {
		defaultWidth: pxToRem(532),
		defaultHeight: pxToRem(181),
		css: ({ dt }) => `
          .p-textarea-default-size {
              width: ${dt('textarea.default.width')};
              height: ${dt('textarea.default.height')};
          }
        `,
	},
};
